
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'PointRedemptionStatusSelect',
  emits: ['update:value'],
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const inputValue = ref<string>();
    const tiers = ref([
      { value: 'fulfilled', label: 'Fulfilled' },
      { value: 'canceled', label: 'Canceled' },
    ]);
    function onChange(event: any) {
      updateModel(event.value);
    }

    function updateModel(val: any) {
      emit('update:value', val);
    }

    return {
      onChange,
      inputValue,
      tiers,
    };
  },
});
